<!-- Carousel images starts -->
<section class="position-relative  ">

    <div id="carouselExampleDark" class="carousel carousel-resposive  carousel-dark slide " data-bs-ride="carousel">
        <div class="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active"
                aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1"
                aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2"
                aria-label="Slide 3"></button>
        </div>
        <div class="carousel-inner">
            <div class="carousel-item active" data-bs-interval="10000">
                <img decoding="async" src="/assets/BrandNewStoreDashboard1.jpg" class="d-block w-100 carousel-resposive" alt=" ">
                <div class="carousel-caption d-none d-md-block">
                </div>
            </div>
            <div class="carousel-item" data-bs-interval="2000">
                <img decoding="async" src=" /assets/BrandNewStoreDashboard2.jpg" class="d-block w-100 carousel-resposive" alt=" ">
                <div class="carousel-caption d-none d-md-block">
                </div>
            </div>
            <div class="carousel-item" data-bs-interval="2000">
                <img decoding="async" src=" /assets/BrandNewStoreDashboard3.jpg" class="d-block w-100 carousel-resposive" alt=" ">
                <div class="carousel-caption d-none d-md-block">
                </div>
            </div>
            <div class="carousel-item" data-bs-interval="2000">
              <img decoding="async" src=" /assets/BrandNewStoreDashboard4.jpg" class="d-block w-100 carousel-resposive" alt=" ">
              <div class="carousel-caption d-none d-md-block">
              </div>
            </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
            <span class=" " aria-hidden="true"><img class="carousel-arrow" src="assets/left-arrow.png"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
            <span class="" aria-hidden="true"><img class="carousel-arrow" src="assets/arrow-right-circle.png"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>
    <!-- Carousel Content -->

    <section class="container-fluid carousel-content-position mw-100">
        <div class="row carousel-content-responsive d-flex align-items-center">
            <div class="col-10 col-md-6 carousel-content">

            </div>
            <!-- Buttons -->
            <section class="row">
                <div class="col-10">
                    <div class="row justify-content-between ">
                        <div class="col-6 col-md-3">
                           <!-- <button class=" btn btn-light shopnow-btn">SHOP NOW</button>-->
                        </div>
                        <div class="col-6 col-md-3 ">
                            <button *ngIf="!authServe.isLoggedIn" (click)="login($event)" class="btn promotion-btn">LOGIN / SIGNUP</button>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    </section>
</section>
<!-- Carousel images ends -->
